import React from "react";
// import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ShowErrorToast, ShowSuccessToast } from 'shared/functions';

// components
import { AppContext } from "components";
import { BaseComponent } from "shared/components";
import { Button } from "shared/components/bulma/button";


import {
    ItemFamilySelect, WashingSelect, CutSelect, ColorSelect, BrandSelect, AttributeSelect,
    SupplierSelect, CategoriesSelect, TagsSelect, ImagesUpload, DetailsSelect
} from "components/ProductComponents";

import { handleUpload } from "shared/functions";
import * as helper from "./helper";

class ModelEdit extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            color: [],
            attributes: [],
            category: "",
            tags: [],
            details: [],
            cuts: [],
            supplier: "",
            name: "",
            SKU: "",
            brand: "",
            season: "All Year",
            washing: '30 Dark Colours',
            itemFamily: "Basic",
            imageURLs: [],
            loading: true,
            file: []
        };

        this.onChange = this.onChange.bind(this);
        this.onChangeImages = this.onChangeImages.bind(this);
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this);

        this.resetState = this.resetState.bind(this);
    }

    componentDidMount = async () => {
        this.context.showLoading();
        const retrievedSKU = this.props.match.params.id;
        const retrievedModel = await helper.getModel(retrievedSKU);
        const { color, attributes, category, tags,
            details,
            cuts,
            supplier,
            name,
            SKU,
            brand,
            season,
            washing,
            item_family,
            imageURLs } = retrievedModel;
        this.setState({
            color, attributes, category, tags,
            details,
            cuts,
            supplier,
            name,
            SKU,
            brand,
            season,
            washing,
            itemFamily: item_family,
            imageURLs,
            loading: false
        });

        this.context.hideLoading();
        toast.configure({
            autoClose: 2000,
            draggable: false
        });
    };

    onChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onChangeImages(images) {
        let cleanedImages = Object.keys(images);
        cleanedImages = cleanedImages.filter((key) => images[key].length > 0);
        const newImageURLs = cleanedImages.map((key) => images[key][0].preview);

        this.setState({
            file: images.file,
            imageURLs: newImageURLs
        });
    }

    onChangeCheckbox(event) {
        const { name } = event.currentTarget;
        const checkboxValue = this.state[name];
        this.setState({ [name]: !checkboxValue });
    }

    updateModel = async () => {
        await this.context.showLoading();

        const {
            color,
            attributes,
            category,
            tags,
            cuts,
            supplier,
            details,
            name,
            brand,
            season,
            washing,
            itemFamily,
            imageURLs,
            SKU,
            file
        } = this.state;

        const role = localStorage.getItem('role');

        if (file && file.length > 0) {
            file.url = await handleUpload(file[0], SKU, supplier);
            imageURLs[0] = file.url;
            this.setState(imageURLs);
        }

        const payload = {
            color,
            attributes,
            category,
            tags,
            cuts,
            supplier,
            details,
            name,
            brand,
            season,
            washing,
            SKU,
            updated: { at: +new Date(), from: role },
            item_family: itemFamily,
            imageURLs
        };

        try {
            helper.verifyRequiredFields(this.state);
        } catch (error) {
            ShowErrorToast(error.message);
            return;
        }

        try {
            const count = await helper.updateModel(payload);
            await this.context.hideLoading();

            this.resetState();
            ShowSuccessToast(`Model and ${count} products updated successfully.`);

            this.props.history.push(`/overstock`);

        } catch (error) {
            ShowErrorToast(error.message);
        };
    };

    resetState = () => {
        this.setState({
            SKU: "",
            color: [],
            attributes: [],
            name: "",
            category: "",
            tags: [],
            details: [],
            cuts: [],
            brand: "",
            season: "All Year",
            washing: '30 Dark Colours',
            itemFamily: "Basic",
            imageURLs: [],
            file: []
        });

    };

    addClicked = async () => {
        this.props.history.push(`/overstock/${this.state.SKU}/upload`);
    }

    clicked = async () => {
        this.props.history.push(`/overstock/${this.state.SKU}/products`);
    }

    render() {
        if (this.state.loading) {
            return (
                <p></p>
            )
        }

        return (
            <>
                <div className="container has-text-centered mt-4 py-4">
                    <div className="columns">
                        <div className="column">
                            <p className="title is-size-2 centered">
                                Edit: {this.state.SKU}
                            </p>
                        </div>
                        <div className="column is-2 is-right">
                            <Button onClick={this.addClicked} className="is-info">
                                <span className="icon-text">
                                    <span className="icon">
                                        <i className="fas fa-plus-circle"></i>
                                    </span>
                                    <span>Upload Products</span>
                                </span >
                            </Button>
                        </div>
                        <div className="column is-2 is-right">
                            <Button onClick={this.clicked} className="is-primary">
                                <span className="icon-text">
                                    <span className="icon">
                                        <i className="fas fa-plus-circle"></i>
                                    </span>
                                    <span>See all Products</span>
                                </span >
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="columns is-gapless">

                    <div className="column is-3 container m-4 pt-4">
                        <ImagesUpload size="is-big" value={this.state.imageURLs} onChange={this.onChangeImages} />
                    </div>

                    <div className="column">
                        <div className="container mt-4 pt-4">
                            <form noValidate>
                                {/* FIRST SECTION */}
                                <div className="columns">
                                    <div className="column px-6 is-6">
                                        <CategoriesSelect name="category" value={this.state.category} label="Categories" onChange={this.onChange} />
                                        <ColorSelect name="color" value={this.state.color} label="Colors" id="color-select" onChange={this.onChange} />
                                        <AttributeSelect name="attributes" value={this.state.attributes} label="Attributes" id="attribute-select" onChange={this.onChange} />
                                        <TagsSelect name="tags" id="tag-select" value={this.state.tags} placeholder="Tags" label="Tags" onChange={this.onChange} />
                                        <DetailsSelect name="details" id="details-select" value={this.state.details} placeholder="Details" label="Details" onChange={this.onChange} />
                                        <CutSelect category={this.state.cuts} name="cuts" id="cut-select" value={this.state.cuts} label="Cuts" onChange={this.onChange} />

                                    </div>
                                    <div className="column px-6 is-6">
                                        <SupplierSelect name="supplier" value={this.state.supplier} id="supplier-select" label="Supplier" onChange={this.onChange} />

                                        <div className="field">
                                            <label className="label">Name</label>
                                            <div className="control">
                                                <input
                                                    className="input"
                                                    name="name"
                                                    type="text"
                                                    value={this.state.name}
                                                    onChange={this.onChange}
                                                    placeholder="Name" />
                                            </div>
                                        </div>

                                        <BrandSelect name="brand" value={this.state.brand} id="brand-select" label="Brand" onChange={this.onChange} />
                                        <WashingSelect name="washing" value={this.state.washing} id="washing-select" label="Washing" onChange={this.onChange} />

                                        <ItemFamilySelect name="itemFamily" value={this.state.itemFamily} label="Item Family" id="item-family" onChange={this.onChange} />
                                    </div>
                                    <div className="column">

                                    </div>
                                </div>
                                {/* END SECTION */}


                                <div className="field is-grouped">
                                    <div className="control">
                                        <button
                                            name="submit"
                                            type="button"
                                            className="button is-primary"
                                            onClick={this.updateModel}>Submit</button>
                                    </div>
                                    <div className="control">
                                        <button type="button"
                                            name="reset"
                                            className="button is-primary is-light"
                                            onClick={this.resetState}>Reset</button>
                                    </div>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

ModelEdit.contextType = AppContext;

ModelEdit.propTypes = {
    history: PropTypes.object
};

export { ModelEdit };

